import {routes} from "../../routing/routes";
export const Authorities = {
    Owner: 'Owner',
    Admin: 'Admin',
    Manager: 'Manager',
    Operation: 'Operation',
    Partner: 'Partner',
    Developer: 'Developer',
    BSD: 'BSD',
    Camera_Admin: 'Camera Admin',
};

export const MASTER_ROUTE_MAP = {
    MANAGER: '/vehicleMasterView',
    CAMERA_MASTER: '/cameraMaster',
    DEFAULT: '/vehicleMaster',
};

export const OPERATIONS = {
    READ: Symbol('READ'),
    WRITE: Symbol('WRITE'),
};


export const SUB_ROUTE_ACCESS = {
    gpsQuality:             null, // all roles
    health:                 null, // all roles
    distance:               [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    archiveData:            [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    deviceFrequency:        [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    dateFrequency:          [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    RSU:                    [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    depot:                  [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    haltStatus:             [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    bsdAvailabilityReport:  [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    etaAckMatrix:           [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    vehicleInOutEvent:      [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    deviceConfig:           [Authorities.Owner, Authorities.Admin, Authorities.Manager],
};

export const ACCESS_RIGHTS_LIMIT = {
    [routes.HOME]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager]
    },
    [routes.LIVE_MAP]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager, Authorities.Operation]
    },
    [routes.VEHICLE]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager, Authorities.Operation, Authorities.Camera_Admin],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    },
    [routes.BSD]: {
        [OPERATIONS.READ]: [Authorities.Admin,Authorities.BSD,Authorities.Manager],
        [OPERATIONS.WRITE]: [Authorities.Admin,Authorities.BSD,Authorities.Manager],
    },
    [routes.MASTER]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin],
    },
    [routes.VIEWMASTER]: {
        [OPERATIONS.READ]: [Authorities.Manager],
        [OPERATIONS.WRITE]: [Authorities.Manager],
    },
    [routes.CAMERAMASTER]: {
        [OPERATIONS.READ]: [Authorities.Camera_Admin],
        [OPERATIONS.WRITE]: [Authorities.Camera_Admin],
    },
    [routes.DEVICE]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager, Authorities.Operation, Authorities.Camera_Admin],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    },
    [routes.REGION]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin],
    },
    [routes.PROTOCOL]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin],
    },
    [routes.TRIP]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin],
    },
    [routes.CRON]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin],
    },
    [routes.REPORT]: {
        [OPERATIONS.READ]: [Authorities.Owner, Authorities.Admin, Authorities.Manager, Authorities.Operation],
        [OPERATIONS.WRITE]: [Authorities.Owner, Authorities.Admin, Authorities.Manager],
    },
    [routes.DELAY_ANALYSIS]: {
        [OPERATIONS.READ]: [Authorities.Admin],
        [OPERATIONS.WRITE]: [Authorities.Admin],
    },

};
